module.exports = __webpack_public_path__ + "img/arrow-up-from-line.0723be08.svg";